<template>
  <div class="width-100 min-height flex-column align-items-center justify-content-start bg-image bg-lightgrey" style="padding: 0 3%">
    <div style="height: 11rem; padding: 5%" class="width-100 title-all margin-t flex-column align-items-center justify-content-spaceBetween">
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div class="flex-row align-items-center justify-content-center" @click="show = true">
          <div class="fs-mid fm-sh-medium line-height0">{{ searchObj.time }}</div>
          <div class="qiehuan"></div>
        </div>
        <div class="flex-row align-items-center justify-content-center">
          <div class="fs-mid-sml fm-sh-medium">稿件总数</div>
          <div class="fm-sh-medium fs-mid margin-l" style="color: #1e67f7">{{ itemDetail.totalCnt }}</div>
        </div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-bold" style="color: #1e67f7">{{ itemDetail.baseCntIn3day }}</div>
          <div class="fs-mid black fm-sh-regular">基础数</div>
        </div>
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-bold" style="color: #f68100">{{ itemDetail.popularCntIn3day }}</div>
          <div class="fs-mid black fm-sh-regular">爆款数</div>
        </div>
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-bold" style="color: #1e67f7">
            {{ itemDetail.readCntIn3day > 10000 ? (itemDetail.readCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.readCntIn3day }}
          </div>
          <div class="fs-mid black fm-sh-regular">阅读数</div>
        </div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div
          class="width-28 flex-row align-items-center justify-content-around br-reg"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
        >
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">点赞数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.thumbCntIn3day > 10000 ? (itemDetail.thumbCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.thumbCntIn3day }}
          </div>
        </div>
        <div
          class="width-28 flex-row align-items-center justify-content-around br-reg"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
        >
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">评论数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.commentCntIn3day > 10000 ? (itemDetail.commentCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.commentCntIn3day }}
          </div>
        </div>
        <div
          class="width-28 flex-row align-items-center justify-content-around br-reg"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
        >
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">转发数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.shareCntIn3day > 10000 ? (itemDetail.shareCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.shareCntIn3day }}
          </div>
        </div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="width-100">
      <div
        v-for="(item, key) in list"
        :key="key"
        class="width-100 bg-white br-reg margin-ts flex-column align-items-center justify-content-spaceBetween position-relative"
        style="padding-top: 5%"
      >
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="padding: 0 5% 0 0">
          <div class="flex-row align-items-center justify-content-center">
            <div class="image-left"></div>
            <div class="fs-mid fm-sh-medium margin-ls">
              {{ item.channelName }}
            </div>
          </div>
          <div class="flex-row align-items-center justify-content-center">
            <div class="fs-mid-sml fm-sh-medium">稿件总数</div>
            <div class="fm-sh-medium fs-mid margin-l" style="color: #1e67f7">{{ item.totalCnt }}</div>
          </div>
        </div>
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="padding: 0 5%">
          <div id="left" class="flex-row algin-items-center justify-content-around width-50">
            <!-- <van-circle
              v-model="item.currentRate"
              stroke-width="80"
              :rate="90"
              :clockwise="false"
              size="4rem"
              color="#1e67f7"
              :text="item.currentRate + '%'"
            /> -->
            <div class="flex-column align-items-center justify-content-center">
              <div class="fm-sh-bold fs-20" style="color: #1e67f7">
                {{ item.baseCntIn3day > 10000 ? (item.baseCntIn3day / 10000).toFixed(2) + 'w' : item.baseCntIn3day }}
              </div>
              <div class="fs-mid-sml fm-sh-medium">基础数</div>
            </div>
          </div>
          <div id="right" class="flex-row algin-items-center justify-content-around width-50">
            <!-- <van-circle
              v-model="item.currentRate"
              stroke-width="80"
              :rate="90"
              :clockwise="false"
              size="4rem"
              color="#f68100"
              :text="item.currentRate + '%'"
            /> -->
            <div class="flex-column align-items-center justify-content-center">
              <div class="fm-sh-bold fs-20" style="color: #f68100">
                {{ item.popularCntIn3day > 10000 ? (item.popularCntIn3day / 10000).toFixed(2) + 'w' : item.popularCntIn3day }}
              </div>
              <div class="fs-mid-sml fm-sh-medium">爆款数</div>
            </div>
          </div>
        </div>
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="padding: 0 5%">
          <div
            class="width-28 flex-row align-items-center justify-content-around br-reg"
            style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
          >
            <div class="fs-sml fm-sh-regular" style="color: #1e67f7">点赞数</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.thumbCntIn3day > 10000 ? (item.thumbCntIn3day / 10000).toFixed(2) + 'w' : item.thumbCntIn3day }}
            </div>
          </div>
          <div
            class="width-28 flex-row align-items-center justify-content-around br-reg"
            style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
          >
            <div class="fs-sml fm-sh-regular" style="color: #1e67f7">评论数</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.commentCntIn3day > 10000 ? (item.commentCntIn3day / 10000).toFixed(2) + 'w' : item.commentCntIn3day }}
            </div>
          </div>
          <div
            class="width-28 flex-row align-items-center justify-content-around br-reg"
            style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 0"
          >
            <div class="fs-sml fm-sh-regular" style="color: #1e67f7">转发数</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.shareCntIn3day > 10000 ? (item.shareCntIn3day / 10000).toFixed(2) + 'w' : item.shareCntIn3day }}
            </div>
          </div>
        </div>
        <div class="width-100 flex-row align-items-center justify-content-center margin-ts" @click="showItem(item, key)" style="padding: 0 5%">
          <div
            class="fm-sh-medium fs-sml grey-999 textAlign-c"
            style="background: #eef1f5; width: 4rem; height: 1.25rem; border-top-left-radius: 0.375rem; border-top-right-radius: 0.375rem"
          >
            查看详细
          </div>
        </div>
      </div>
    </van-list>
    <div style="height: 120px; width: 100%"></div>
    <Tabbar active="5" />
    <van-overlay :show="show" class="flex-column align-items-center justify-content-end" style="z-index: 9999">
      <van-datetime-picker
        class="width-100"
        style="z-index: 9999"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="show = false"
        @confirm="onConfirm"
      />
    </van-overlay>
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue';
import { getArticleStatistic, getChannelArticleStatisticList } from '@/api/zhishu';
export default {
  data() {
    return {
      currentDate: '',
      maxDate: new Date(),
      minDate: new Date(2023, 1, 1),
      show: false,
      list: [],
      itemDetail: {
        baseCntIn3day: '',
        popularCntIn3day: '',
        readCntIn3day: '',
        thumbCntIn3day: '',
        commentCntIn3day: '',
        shareCntIn3day: ''
      },
      searchObj: {
        time: '',
        beginTime: '',
        endTime: '',
        beginTime1: '',
        endTime1: '',
        pageNum: 0,
        pageSize: 10, // 每页显示条数
        total: ''
      },
      loading: false,
      finished: false,
      columns: [
        { text: '1月', key: 1 },
        { text: '2月', key: 2 },
        { text: '3月', key: 3 },
        { text: '4月', key: 4 },
        { text: '5月', key: 5 },
        { text: '6月', key: 6 },
        { text: '7月', key: 7 },
        { text: '8月', key: 8 },
        { text: '9月', key: 9 },
        { text: '10月', key: 10 },
        { text: '11月', key: 11 },
        { text: '12月', key: 12 }
      ],
      objList: {}
    };
  },
  components: {
    Tabbar
  },
  beforeMount() {
    let date = new Date();
    this.searchObj.time = date.getMonth() + 1 + '月';
    this.searchObj.beginTime = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) + '-01';
    this.searchObj.endTime = this.$dayjs(date).format('YYYY-MM-DD');
    this.getArticleStatistic();
  },
  methods: {
    getArticleStatistic() {
      getArticleStatistic({ beginTime: this.searchObj.beginTime, endTime: this.searchObj.endTime })
        .then((res) => {
          this.itemDetail = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getChannelArticleStatisticList() {
      await getChannelArticleStatisticList({
        pageNum: this.searchObj.pageNum,
        pageSize: this.searchObj.pageSize,
        beginTime: this.searchObj.beginTime,
        endTime: this.searchObj.endTime
      })
        .then((res) => {
          this.searchObj.total = res.total;
          let objList = this.objList;
          objList[this.searchObj.pageNum] = res.rows;
          let list = [];
          for (let key in objList) {
            list = list.concat(objList[key]);
          }
          this.list = list;
          if (res.total < this.searchObj.pageNum * this.searchObj.pageSize) {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showItem(item) {
      console.log(item);
      this.$router.push({ path: '/zhishusecond', query: { id: item.channelId } });
    },
    onConfirm(key) {
      console.log(key);
      let date = new Date(key);
      let lastDay = new Date(date.getTime() - 1000 * 60 * 60 * 24); //获取当月最后一天日期
      this.searchObj.beginTime = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) + '-' + '01';
      this.searchObj.endTime =
        date.getFullYear() +
        '-' +
        (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) +
        '-' +
        (lastDay.getDate() < 10 ? `0${lastDay.getDate()}` : lastDay.getDate());
      this.searchObj.time = key.text;
      this.getArticleStatistic();
      this.finished = false;
      this.searchObj.time = date.getMonth() + 1 + '月';
      this.loading = true;
      this.searchObj.pageNum = 0;
      this.onLoad();
      this.show = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getChannelArticleStatisticList();
    }
  }
};
</script>

<style scoped>
::v-deep #left .van-circle__text {
  color: #1e67f7;
  font-size: 1rem;
  font-family: sh-sc-bold;
}
::v-deep #right .van-circle__text {
  color: #f68100;
  font-size: 1rem;
  font-family: sh-sc-bold;
}
.bg-image {
  background-image: url('../assets/image/prizeManagement/bg-image.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.title-all {
  background-image: url('../assets/image/luckyDrawDetails/titleall.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.image-left {
  width: 0.375rem;
  height: 1rem;
  background-image: url('../assets/image/luckyDrawDetails/image-left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.qiehuan {
  width: 3rem;
  height: 1rem;
  background-image: url('../assets/image/luckyDrawDetails/qiehuan.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep .van-picker__columns {
  z-index: 9999;
}
</style>
